// 定数定義
const GCP_PROJECT = 'fukudakg'
const DOMAIN = `${GCP_PROJECT}.as-ta.net`
const GCS = `gcs.${DOMAIN}`

module.exports = {
  GCP_PROJECT,
  FUNCTION_REGION: 'us-central1',
  DOMAIN,
  GCS,
  SERVICE_URLS: {
    GENERATE_LEDGERS: 'https://generateledgers-7avr3msaia-uc.a.run.app',
  },
}
